/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TestResultFromJSON, TestResultToJSON } from './TestResult';
/**
 * Check if a given object implements the SendTestResponse interface.
 */
export function instanceOfSendTestResponse(value) {
    if (!('results' in value) || value['results'] === undefined)
        return false;
    return true;
}
export function SendTestResponseFromJSON(json) {
    return SendTestResponseFromJSONTyped(json, false);
}
export function SendTestResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'results': (json['results'].map(TestResultFromJSON)),
    };
}
export function SendTestResponseToJSON(json) {
    return SendTestResponseToJSONTyped(json, false);
}
export function SendTestResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'results': (value['results'].map(TestResultToJSON)),
    };
}
